import { Outlet } from "react-router-dom";
import Header from "../components/header/header";
import Footer from "../components/footer/footer";
import ScrollToTop from "../components/scroll-to-top/scroll-top";

const DefaultLayout = () => {
  return (
    <>
      <Header />
      <div className="main-section">
        <Outlet />
      </div>
      <Footer />
      <ScrollToTop />
    </>
  );
};

export default DefaultLayout;
